import selectSiblings from '../helpers/siblings';

document.querySelectorAll('.file-field input[type=file]').forEach((fileField) => {
  fileField.addEventListener('change', (e) => {
    let filename = e.currentTarget.value;
    filename = filename.split(/(\\|\/)/g).pop();

    selectSiblings(e.currentTarget, '.form-field').forEach((sibling) => {
      sibling.innerHTML = filename;
    });
  });
});
